import { JSX, useCallback, useEffect, useState } from "react";

import { HexColorInput, HexColorPicker } from "react-colorful";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

export type ColourPickerProps = {
	value: string; // HEX value
	disabled?: boolean;

	onChange: (value: string) => void;
};

function ColourPicker(props: ColourPickerProps): JSX.Element {
	const [showPicker, setShowPicker] = useState(false);
	const [color, setColor] = useState(props.value);

	useEffect(() => setColor(props.value), [props.value]);

	const openPicker = useCallback((): void => {
		if (props.disabled === true) {
			return;
		}

		setShowPicker(true);
	}, []);

	const closePicker = useCallback((): void => {
		setShowPicker(false);
		if (props.value !== color) {
			props.onChange(color);
		}
	}, [props.onChange, color]);

	return (
		<>
			<div
				style={{
					width: "100%",
					aspectRatio: "3 / 2",
					backgroundColor: props.value,
					cursor: props.disabled ? "default" : "pointer"
				}}
				onClick={openPicker}
			/>
			<Dialog open={showPicker} onClose={closePicker}>
				<DialogContent sx={{ textAlign: "center" }}>
					<HexColorPicker color={color} onChange={setColor} />
					<HexColorInput prefixed color={color} onChange={setColor} />
				</DialogContent>
			</Dialog>
		</>
	);
}

export default ColourPicker;
